module.exports = __webpack_public_path__ + "img/ashpa_yes.9bf4c306.png";